<template>
    <div class="form-field form-number" :rel="name" v-bind:class="{'has-suffix': suffix, 'form-required': required, 'form-focus': focus, 'form-disabled':isDisabled}">
        <div class="form-label" v-show="label">
            <label>{{ label }}</label>
        </div>
        <div class="form-hint" v-show="hint">{{ hint }}</div>
        <div class="form-input">
            <div class="form-input-wrapper" lang="fr-CH">
                <input type="number"
                       v-bind:style="width?'width:'+width+'px':''"
                       :step="stepValue"
                       value=""
                       :disabled="isDisabled"
                       v-model="internalValue"
                       :placeholder="placeholder"
                       @keypress="restrictChars($event)"
                       @focus="focus=true"
                       @blur="focus=false"/>
                <span class="suffix" v-if="suffix"><span>{{ suffix }}</span></span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value','label', 'hint', 'name','placeholder','suffix','step','required','disabled', 'width'],
        data: function () {
            return {
                internalValue: '',
                oneTime: null,
                focus: false
            }
        },
        created: function() {
            this.internalValue = this.value;
            this.stepValue = this.step ? this.step : 1
            this.isDisabled = this.disabled && (this.disabled == 'true' || this.disabled == true) ? true : false
        },
        methods: {
            restrictChars: function($event) {
                /*
                if( [46,48,49,50,51,52,53,54,55,56,57].indexOf($event.charCode) >= 0 ){
                    console.log("numeric", $event.charCode)
                    return true;
                }
                $event.preventDefault();
                */
            },
            updateValue: function(val)
            {

                let diff = Math.round((val*100)%(this.stepValue*100))/100
                diff = diff >= this.stepValue ? 0 : diff

                if( diff > 0 ){
                    val =  Math.round(val*100 - diff*100)/100;
                }

                return val;//parseFloat(val).toFixed(2);

            }
        },
        watch: {
            'value'(newVal, oldVal) {
                this.internalValue = this.updateValue(newVal);
            },
            'internalValue'(newVal, oldVal) {
                if( newVal && this.internalValue != this.value ){
                    this.internalValue = this.updateValue(newVal);
                }
                this.$emit('input', this.internalValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/form/Number.vue